import { Roles, Subjects } from "settings/permissions";

export const adminConsolePermissions = {
  accountDetails: {
    subject: Subjects.Client_Information,
    role: Roles.Read,
  },
  subscription: {
    subject: Subjects.Billing,
    role: Roles.Read,
  },
  team: {
    subject: Subjects.User_Management,
    role: Roles.Read,
  },
  data_collector: {
    subject: Subjects.CollectorAdmin,
    role: Roles.Read,
  },
  tags: {
    subject: Subjects.Tagging,
    role: Roles.Read,
  },
  costManagement: {
    subject: Subjects.Cost_Management,
    role: Roles.Admin,
  },
  integrations: {
    subject: Subjects.Integration_Admin,
    role: Roles.Read,
  },
  alertingManagement: {
    subject: Subjects.Alerting_Management,
    role: Roles.Read,
  },
  reporting: {
    subject: Subjects.Reporting,
    role: Roles.Read,
  },
  opportunities: {
    subject: Subjects.Reporting,
    role: Roles.Read,
  },
};

export const REDIRECT_TO_DATA_COLLECTORS = "/admin_console/collections/data_collectors";
export const REDIRECT_TO_CREDENTIALS = "/admin_console/collections/collector_credentials";
export const REDIRECT_TO_RESOURCES = "/admin_console/collections/resources";
export const REDIRECT_TO_NOTIFICATION_CHANNELS = "/admin_console/monitoring/notification_channels";
export const REDIRECT_TO_SILENCING_WINDOWS = "/admin_console/monitoring/silencing_windows";
export const REDIRECT_TO_ALERT_TYPES = "/admin_console/monitoring/alert_types";
export const REDIRECT_TO_ACCOUNT = "/admin_console/account";
export const REDIRECT_TO_TEAM = "/admin_console/team";
export const REDIRECT_TO_INTEGRATIONS = "/admin_console/integrations";
export const REDIRECT_TO_REPORT_TEMPLATES = "/admin_console/reporting/templates";
export const REDIRECT_TO_REPORT_SUBSCRIPTIONS = "/admin_console/reporting/subscriptions";
export const REDIRECT_TO_REPORT_HISTORY = "/admin_console/reporting/history";
export const REDIRECT_TO_OPPORTUNITY_POLICIES = "/admin_console/opportunity/opportunity_policies";
export const REDIRECT_TO_TAGS = "/admin_console/tags";
export const REDIRECT_TO_COST_MANAGEMENT = "/admin_console/cost_management";
export const REDIRECT_TO_MONITORING_PROFILES = "/admin_console/monitoring/profiles";

export const adminConsolePages = {
  id: "admin_console",
  label: "Admin Console",
  path: "/admin_console",
  icon: "advancedSettingsApp",
  permissions: {
    subject: Subjects.Admin_Console,
    role: Roles.Read,
  },
  items: [
    {
      permissions: adminConsolePermissions.accountDetails,
      label: "Account",
      path: "/admin_console/account",
      requireClientSelection: true,
    },
    {
      permissions: adminConsolePermissions.subscription,
      label: "Subscriptions",
      path: "/admin_console/subscriptions",
      requireClientSelection: true,
    },
    {
      permissions: adminConsolePermissions.team,
      label: "Team",
      path: "/admin_console/team",
      requireClientSelection: true,
    },
    {
      path: "/admin_console/tags",
      requireClientSelection: true,
      label: "Tags",
      permissions: adminConsolePermissions.tags,
    },
    {
      path: "/admin_console/cost_management",
      requireClientSelection: true,
      label: "Cost Management",
      permissions: adminConsolePermissions.costManagement,
    },
    {
      path: "/admin_console/integrations",
      requireClientSelection: true,
      label: "Integration",
      permissions: adminConsolePermissions.integrations,
      topNavLinks: [
        {
          path: "/admin_console/integrations",
          label: "Integrations",
        },
      ],
    },
    {
      permissions: adminConsolePermissions.data_collector,
      label: "Collection",
      path: "/admin_console/collections/data_collectors",
      requireClientSelection: true,
      topNavLinks: [
        {
          label: "Data Collectors",
          path: "/admin_console/collections/data_collectors",
        },
        {
          label: "Credentials",
          path: "/admin_console/collections/collector_credentials",
        },
        {
          label: "Resources",
          path: "/admin_console/collections/resources",
        },
      ],
    },
    {
      permissions: adminConsolePermissions.alertingManagement,
      label: "Monitoring",
      path: "/admin_console/monitoring/notification_channels",
      requireClientSelection: true,
      topNavLinks: [
        {
          label: "Notification Channels",
          path: "/admin_console/monitoring/notification_channels",
        },
        {
          label: "Alert Types",
          path: "/admin_console/monitoring/alert_types",
        },
        {
          label: "Custom Monitoring Queries",
          path: "/admin_console/monitoring/custom_monitoring_queries",
        },
        {
          label: "Profiles",
          path: "/admin_console/monitoring/profiles",
        },
        {
          label: "Alert Rules",
          path: "/admin_console/monitoring/alert_rules",
        },
        {
          label: "Silencing Windows",
          path: "/admin_console/monitoring/silencing_windows",
        },
      ],
    },
    {
      permissions: adminConsolePermissions.reporting,
      label: "Reporting",
      path: "/admin_console/reporting",
      requireClientSelection: true,
      topNavLinks: [
        {
          label: "Report Templates",
          path: "/admin_console/reporting/templates",
        },
        {
          label: "Report Subscriptions",
          path: "/admin_console/reporting/subscriptions",
        },
        {
          label: "Report History",
          path: "/admin_console/reporting/history",
        },
      ],
    },
    {
      permissions: adminConsolePermissions.opportunities,
      label: "Opportunities",
      path: "/admin_console/opportunity",
      requireClientSelection: true,
      topNavLinks: [
        {
          label: "Opportunity Types",
          path: "/admin_console/opportunity/opportunity_types",
        },
        {
          label: "Opportunity Policies",
          path: "/admin_console/opportunity/opportunity_policies",
        },
      ],
    },
  ],
};
